import { GetManifestParsedTripsInput, GetManifestParsedTripsResponse } from '@/models/gen/graphql';

import { GetManifestParsedTripsDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';

type GetManifestParsedTripsGraphApiResponse = GraphApiResponse<typeof GetManifestParsedTripsDocument>;

const title = 'Get Manifest Parsed Trips';

const getManifestParsedTripsResponseSelector = (res: GetManifestParsedTripsGraphApiResponse): GetManifestParsedTripsResponse =>
  res?.getManifestParsedTrips as GetManifestParsedTripsResponse;

const [_runGetManifestParsedTrips, runRefetchGetManifestParsedTrips] = graphApi(GetManifestParsedTripsDocument, {
  onError: (res: GetManifestParsedTripsGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const getManifestParsedTrips = async (manifestImportId: string): Promise<GetManifestParsedTripsResponse> => {
  const input: GetManifestParsedTripsInput = { manifestImportId };
  const res = await runRefetchGetManifestParsedTrips({ input });

  return getManifestParsedTripsResponseSelector(res);
};

export const useGetManifestParsedTrips = createGraphApiHook(getManifestParsedTrips);

export default getManifestParsedTrips;
